import Nav from '../Nav/Nav.vue'
import Header from '../Header/Header.vue'
import {mapState} from 'vuex'
import ProductFilter from './ProductFilter/ProductFilter.vue'
import Product from './Product/Product.vue'

export default {
    name: 'Home',
    components: {
        Nav,
        Header,
        ProductFilter,
        Product
    },
    data() {
        return {
        }
    },
    computed: {
        ...mapState({
            products: state => state.products.all,
            isLoadingProducts: state => state.products.loadingProducts,
            isErrorInProducts: state => state.products.errorInProducts,
            totalProductsAmount: state => state.products.totalProducts,
        }),
    },
    methods: {
        loadMoreProducts() {
            this.$store.dispatch('products/retrieveProducts');
        },
        async searchProducts(search) {
            this.$store.commit('products/setSearch', search)
            await this.$store.dispatch('products/retrieveProducts');
        }
    },
    created() {
        if (!localStorage.signedIn) {
            this.$router.replace('/')
        }
        this.$store.dispatch('products/retrieveProducts');
        this.$store.dispatch('account/getUser');
        this.$store.dispatch('cart/retrieveShoppingBasket')
        this.$gtag.screenview({
            app_name: 'Retailers',
            screen_name: 'Home',
        })
    },
}